module.exports = __webpack_public_path__ + "static/media/co-shape.ec223f86.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Svgs/co-shape.svg
// module id = 534
// module chunks = 0